import styled from 'styled-components'

import { _M_Medium, _M_Normal, mainColors } from '@avantstay/backoffice-core'

export const SubSectionContainer = styled.div`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  padding: 12px;
  background-color: ${mainColors.white};
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SubSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SubSectionTitle = styled.h4`
  margin: 0;
  color: ${mainColors.black};
  ${_M_Medium};
`

export const SubSectionDescription = styled.p`
  margin: 6px 0 0;
  color: ${mainColors.neutralExtremelyDark};
  ${_M_Normal};
`

export const CustomContentWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
`

export const HighlightedText = styled.span<{ isHighlighted: boolean }>`
  background-color: ${props => (props.isHighlighted ? mainColors.accentLight : 'transparent')};
  padding: ${props => (props.isHighlighted ? '1px 2px' : '0')};
  border-radius: 2px;
`
